import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "store";

import { PeopleWrapper, PeopleItems, Divider, PeopleItem, MobilePeopleWrapper } from "./peopleList.styles";
import { useStoriesDataContext } from "contexts/StoriesContext";
import MyStoriesList from "../MyStoriesList/myStoriesList";
import { useStoryDataContext } from "contexts/StoryContext";
import { useIsMobile } from "hooks";
import AddStoryBtn from "./addStoryBtn";

interface IPeopleList {
  wholeStory: string;
}

function PeopleList({ wholeStory }: IPeopleList) {
  const { stories, storiesLoading } = useStoriesDataContext();
  const isMobile = useIsMobile(767);
  const { story } = useStoryDataContext();
  const { id } = useParams();
  const navigate = useNavigate();
  const { profile } = useAppSelector((state) => state.profile);

  // const [search, setSearch] = useState("");

  if (isMobile) return (
    <MobilePeopleWrapper>
      {profile && <AddStoryBtn />}
      {story && <MyStoriesList name={story.name} wholeStory={wholeStory}/>}
    </MobilePeopleWrapper>
  );

  return (
    <PeopleWrapper>
      {/*<Input*/}
      {/*  prefix={<img src={SearchIcon} alt="search" />}*/}
      {/*  style={{ borderRadius: "8px" }}*/}
      {/*  value={search}*/}
      {/*  onChange={setSearch}*/}
      {/*  placeholder={t("find") + "..."}*/}
      {/*/>*/}
      <PeopleItems>
        {profile && <AddStoryBtn />}

        {!!stories.length && profile && <Divider />}
        {!storiesLoading && stories.map((el, i) => (
          <PeopleItem
            className={el.uuid === id ? "active" : ""}
            onClick={() => navigate(`/${wholeStory}/${el.uuid}`)}
            key={el.name + i}
          >
            {el.name}
          </PeopleItem>
        ))}


      </PeopleItems>
    </PeopleWrapper>
  );
}

export default PeopleList;
